<template>
  <div class="dashboard-container">
    <el-date-picker
      v-model="monthValue"
      @change="pickerchange"
      :clearable="false"
      :editable="false"
      type="month"
      value-format="yyyy-MM"
      class="pickermonth"
      ref="abc"
    >
    </el-date-picker>
    <div @click="agency()" class="pickermonths cursorpointer">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <path
          d="M15.811 23.47c-0.252-0.060-0.47-0.185-0.641-0.356l-10.685-10.685c-0.521-0.521-0.521-1.365 0-1.886s1.365-0.521 1.886 0l9.746 9.746 9.745-9.745c0.521-0.521 1.365-0.521 1.886 0s0.521 1.365 0 1.886l-10.685 10.685c-0.339 0.339-0.816 0.458-1.251 0.355z"
        ></path>
      </svg>
    </div>
    <el-calendar v-model="date" class="width79 border-rd3">
      <template slot="dateCell" slot-scope="{ date, data }">
        <div @click="isSelected(date, data)" class="allcont">
          <div class="solar">
            {{ data.day.split("-")[2] }}
          </div>
          <div class="lunar" :class="{ festival: isFestival(date, data) }">
            {{ solarToLunar(date, data) }}
          </div>

          <div
            v-for="(item, index) in page"
            :key="index"
            class="itemcont width100"
          >
            <div
              v-if="item[0].start_at.substring(0, 10).indexOf(data.day) != -1"
              class="width100"
              style="height: 70px"
            >
              <div
                v-for="(_item, _index) in item"
                :key="_index"
                class="width100"
              >
                <p class="incomplete">
                  {{ _item.title }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </template>
    </el-calendar>
    <div class="width20 border-rd3 backwhite" style="min-height: 85vh">
      <div class="width100 border-rd3 pad-bot20">
        <div
          class="width90 margin-auto"
          style="max-height: 86vh; overflow: scroll"
        >
          <p class="dimensional pad-top20">日程安排</p>
          <p class="f12 bluecolor margin-top20 margin-bot20">
            日期 : {{ changedata }}
          </p>
          <div
            v-for="(item, index) in calepage"
            :key="index"
            style="padding: 10px"
            class="border-rd3"
            @mouseenter="filemouseenter(index)"
            @mouseleave="filemouseleave(index)"
            :class="filemouse == index ? 'backhover' : ''"
          >
            <div class="flex-betweennowrap">
              <div class="flex">
                <div class="bluebor"></div>
                <p class="dimensional f14">
                  {{ item.title }}
                </p>
              </div>

              <div v-if="item.status != 0" class="complete">完成</div>
              <div v-if="item.status == 0" class="nocomplete">未完成</div>
            </div>
            <div
              class="
                dimencont
                f12
                width90
                margin-auto
                lineheight25
                margin-top10
              "
            >
              {{ item.remark }}
              <p class="f12">{{ item.start_at }}</p>
            </div>
            <div
              class="textalign-right"
              v-if="filemouse == index ? true : false"
            >
              <el-button
                style="font-size: 12px"
                v-if="item.status == 0"
                @click="finishday(index)"
                >完成</el-button
              >
              <el-button
                style="font-size: 12px"
                @click="finishdaynull(index)"
                v-if="item.status != 0"
                >未完成</el-button
              >
              <el-button style="font-size: 12px" @click="removeday(index)"
                >删除</el-button
              >
            </div>
          </div>
          <div class="margin-top10">
            <el-button @click="dialogVisibleadd = true">添加日程</el-button>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="添加日程"
      :visible.sync="dialogVisibleadd"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="addboxadd"
    >
      <div>
        <p class="width100 pad-bot10">日程名称</p>
        <el-input
          clear="width80"
          v-model="inputname"
          placeholder="请输入内容"
        ></el-input>
      </div>
      <div class="margin-top10 datepicker">
        <p class="width100 pad-bot10">开始时间</p>

        <el-time-picker
          v-model="valuetime"
          placeholder="选择时间"
          value-format="HH:mm:ss"
        >
        </el-time-picker>
      </div>
      <div class="margin-top10">
        <p class="width100 pad-bot10">备注</p>
        <el-input
          type="textarea"
          :autosize="autosize"
          clear="width80"
          v-model="inputtextarea"
          placeholder="请输入内容"
        ></el-input>
      </div>
      <!-- <span @click="addprocess()" class="buttonsure margin-top10">确 定</span> -->
      <div class="width98 margin-auto margin-top20 textalign-right">
        <el-button @click="dialogVisibleadd = false">取 消</el-button>
        <el-button class="margin-top20" type="primary" @click="addprocess()">
          确 定
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
 
<script>
import calendar from "@/utils/calendar.js";
import {
  caleindex,
  calesave,
  calefinish,
  caledel,
  calefind,
} from "@/api/patent/patent.api";
export default {
  name: "Dashboard",
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      date: new Date(),
      // 根据selectedDates设置选中日期
      selectedDates: ["2020-04-12", "2020-04-15", "2020-04-24"],
      page: "",
      calepage: [],
      changedata: "",
      dialogVisibleadd: false,
      inputname: "",
      inputtime: "",
      valuetime: "",
      inputtextarea: "",
      Scheduledetails: "",
      detailstitle: "",
      detailscont: "",
      finishid: "",
      status: "",
      filemouse: -1,
    };
  },

  computed: {
    monthValue: {
      get: function () {
        return this.date;
      },
      //当筛选时间的时候调用set方法，赋值给日历组件绑定的v-model
      set: function (newValue) {
        this.date = newValue;
      },
    },
  },
  methods: {
    filemouseenter(index) {
      this.filemouse = index;
    },
    filemouseleave(index) {
      this.filemouse = -1;
    },
    // 是否选中日期
    isSelected: function (slotDate, slotData) {
      window.sessionStorage.setItem("deitleday", slotData.day.substring(0, 7));
      this.inputtime = slotData.day;
      caleindex({
        month: slotData.day.substring(0, 7),
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.page = Object.values(res.data.data);
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
      calefind({
        date: slotData.day,
      }).then((res) => {
        if (res.data.code == 200) {
          this.calepage = res.data.data;
          this.changedata = slotData.day;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 添加进程
    addprocess() {
      calesave({
        title: this.inputname,
        start_at: this.inputtime + " " + this.valuetime,
        remark: this.inputtextarea,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "添加成功",
            type: "success",
          });

          this.inputname = "";
          this.inputtextarea = "";
          this.dialogVisibleadd = false;
          caleindex({
            month: window.sessionStorage.getItem("deitleday"),
          }).then((res) => {
            if (res.data.code == 200) {
              this.$loading.hide(); // 隐藏loading
              this.page = Object.values(res.data.data);
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
          calefind({
            date: this.changedata,
          }).then((res) => {
            if (res.data.code == 200) {
              this.calepage = res.data.data;
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 完成日程
    finishday(index) {
      calefinish({
        id: this.calepage[index].id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "已完成",
            type: "success",
          });
          // 成功创新请求数据
          caleindex({
            month: window.sessionStorage.getItem("deitleday"),
          }).then((res) => {
            if (res.data.code == 200) {
              this.$loading.hide(); // 隐藏loading
              this.page = Object.values(res.data.data);
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
          calefind({
            date: this.changedata,
          }).then((res) => {
            if (res.data.code == 200) {
              this.calepage = res.data.data;
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 未完成
    finishdaynull(index) {
      calefinish({
        id: this.calepage[index].id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "未完成",
            type: "success",
          });
          // 成功创新请求数据
          caleindex({
            month: window.sessionStorage.getItem("deitleday"),
          }).then((res) => {
            if (res.data.code == 200) {
              this.$loading.hide(); // 隐藏loading
              this.page = Object.values(res.data.data);
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
          calefind({
            date: this.changedata,
          }).then((res) => {
            if (res.data.code == 200) {
              this.calepage = res.data.data;
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    // 删除日程
    removeday(index) {
      this.$confirm("此操作将删除此日程, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          caledel({
            id: this.calepage[index].id,
          }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                showClose: true,
                message: "已删除",
                type: "success",
              });
              // 成功创新请求数据
              caleindex({
                month: window.sessionStorage.getItem("deitleday"),
              }).then((res) => {
                if (res.data.code == 200) {
                  this.$loading.hide(); // 隐藏loading
                  this.page = Object.values(res.data.data);
                } else {
                  this.dialogVisiblenull = true;
                  this.errormessage = res.data.msg;
                }
              });
              calefind({
                date: this.changedata,
              }).then((res) => {
                if (res.data.code == 200) {
                  this.calepage = res.data.data;
                } else {
                  this.dialogVisiblenull = true;
                  this.errormessage = res.data.msg;
                }
              });
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    // 是否节假日
    isFestival(slotDate, slotData) {
      let solarDayArr = slotData.day.split("-");
      let lunarDay = calendar.solar2lunar(
        solarDayArr[0],
        solarDayArr[1],
        solarDayArr[2]
      );

      // 公历节日\农历节日\农历节气
      let festAndTerm = [];
      festAndTerm.push(
        lunarDay.festival == null ? "" : " " + lunarDay.festival
      );
      festAndTerm.push(
        lunarDay.lunarFestival == null ? "" : "" + lunarDay.lunarFestival
      );
      festAndTerm.push(lunarDay.Term == null ? "" : "" + lunarDay.Term);
      festAndTerm = festAndTerm.join("");

      return festAndTerm != "";
    },
    // 公历转农历
    solarToLunar(slotDate, slotData) {
      let solarDayArr = slotData.day.split("-");
      let lunarDay = calendar.solar2lunar(
        solarDayArr[0],
        solarDayArr[1],
        solarDayArr[2]
      );

      // 农历日期
      let lunarMD = lunarDay.IMonthCn + lunarDay.IDayCn;

      // 公历节日\农历节日\农历节气
      let festAndTerm = [];
      festAndTerm.push(
        lunarDay.festival == null ? "" : " " + lunarDay.festival
      );
      festAndTerm.push(
        lunarDay.lunarFestival == null ? "" : "" + lunarDay.lunarFestival
      );
      festAndTerm.push(lunarDay.Term == null ? "" : "" + lunarDay.Term);
      festAndTerm = festAndTerm.join("");

      return festAndTerm == "" ? lunarMD : festAndTerm;
    },
    // 下拉框日期
    pickerchange(val) {
      this.date = new Date(this.date);
      caleindex({
        month: val,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.page = Object.values(res.data.data);
          window.sessionStorage.setItem("deitleday", val);
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
      calefind({
        date: val + "-" + "01",
      }).then((res) => {
        if (res.data.code == 200) {
          this.calepage = res.data.data;
          this.changedata = val + "-" + "01";
          this.inputtime = val + "-" + "01";
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 日期选择事件代理
    agency() {
      this.$refs.abc.focus();
    },
  },
  watch: {},
  created() {
    window.sessionStorage.setItem("default", "个人中心");
    this.$nextTick(() => {
      // 点击前一个月
      let prevBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(1)"
      );
      prevBtn.addEventListener("click", (e) => {
        var y = this.date.getFullYear();
        var m = this.date.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        var s =
          this.date.getDate() > 9
            ? this.date.getDate()
            : "0" + this.date.getDate();
        caleindex({
          month: y + "-" + m,
        }).then((res) => {
          if (res.data.code == 200) {
            this.$loading.hide(); // 隐藏loading
            this.page = Object.values(res.data.data);
            window.sessionStorage.setItem("deitleday", y + "-" + m);
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
        calefind({
          date: y + "-" + m + "-" + s,
        }).then((res) => {
          if (res.data.code == 200) {
            this.calepage = res.data.data;
            this.changedata = y + "-" + m + "-" + s;
            this.inputtime = y + "-" + m + "-" + s;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      });
      //点击下一个月
      let nextBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(3)"
      );
      nextBtn.addEventListener("click", (e) => {
        var y = this.date.getFullYear();
        var m = this.date.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        var s =
          this.date.getDate() > 9
            ? this.date.getDate()
            : "0" + this.date.getDate();
        caleindex({
          month: y + "-" + m,
        }).then((res) => {
          if (res.data.code == 200) {
            this.$loading.hide(); // 隐藏loading
            this.page = Object.values(res.data.data);
            window.sessionStorage.setItem("deitleday", y + "-" + m);
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
        calefind({
          date: y + "-" + m + "-" + s,
        }).then((res) => {
          if (res.data.code == 200) {
            this.calepage = res.data.data;
            this.changedata = y + "-" + m + "-" + s;
            this.inputtime = y + "-" + m + "-" + s;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      });
      //点击今天
      let todayBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(2)"
      );
      todayBtn.addEventListener("click", (e) => {
        var y = this.date.getFullYear();
        var m = this.date.getMonth() + 1;
        var s =
          this.date.getDate() > 9
            ? this.date.getDate()
            : "0" + this.date.getDate();
        m = m < 10 ? "0" + m : m;
        caleindex({
          month: y + "-" + m,
        }).then((res) => {
          if (res.data.code == 200) {
            this.$loading.hide(); // 隐藏loading
            this.page = Object.values(res.data.data);
            window.sessionStorage.setItem("deitleday", y + "-" + m);
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
        calefind({
          date: y + "-" + m + "-" + s,
        }).then((res) => {
          if (res.data.code == 200) {
            this.calepage = res.data.data;
            this.changedata = y + "-" + m + "-" + s;
            this.inputtime = y + "-" + m + "-" + s;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      });
    });

    var dd = this.date;
    dd.setDate(dd.getDate()); //获取AddDayCount天后的日期
    var y = dd.getFullYear();
    var m =
      dd.getMonth() + 1 > 9 ? dd.getMonth() + 1 : "0" + (dd.getMonth() + 1); //获取当前月份的日期
    var s = dd.getDate() > 9 ? dd.getDate() : "0" + dd.getDate();
    this.$loading.show(); // 显示loading
    window.sessionStorage.setItem("deitleday", y + "-" + m);
    caleindex({
      month: y + "-" + m,
    }).then((res) => {
      if (res.data.code == 200) {
        this.$loading.hide(); // 隐藏loading
        this.page = Object.values(res.data.data);
      } else {
        this.$loading.hide(); // 隐藏loading
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    calefind({
      date: y + "-" + m + "-" + s,
    }).then((res) => {
      if (res.data.code == 200) {
        this.calepage = res.data.data;
        this.changedata = y + "-" + m + "-" + s;
        this.inputtime = y + "-" + m + "-" + s;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {},
};
</script>
 
<style scoped>
.dashboard-container {
  width: 98%;
  margin: 10px auto 0;
  position: relative;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
}
.bluebor {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #52c5cb;
  position: relative;
  top: 4px;
  margin-right: 10px;
}
/**隐藏上一月、本月、下一月*/
.el-calendar__button-group {
  display: none;
}
/**月份居中*/
div /deep/.el-calendar__title {
  font-size: 24px;
}
/**日期div的样式*/
.el-calendar-table tr td:first-child {
  border-left: 0px;
}
.el-calendar-table td {
  min-width: 110px;
  border-right: 0px;
}
.el-calendar-table td.is-selected {
  background-color: white;
}
div /deep/ .el-calendar-table .el-calendar-day {
  height: 110px !important;
}
div /deep/.el-calendar__button-group .el-button-group > button:nth-child(1) {
  margin-bottom: 10px;
  width: 88px;
  height: 32px;
  color: #353a44;
  background: #e3e3e3;
  margin-right: 3px;
}
div /deep/.el-calendar__button-group .el-button-group > button:nth-child(3) {
  width: 88px;
  height: 32px;
  color: #353a44;
  background: #e3e3e3;
}
div /deep/.el-calendar__button-group .el-button-group > button:nth-child(2) {
  width: 88px;
  height: 32px;
  color: #353a44;
  background: #e3e3e3;
  margin-right: 3px;
}
.allcont {
  height: 100%;
}

.el-calendar-table .el-calendar-day > div {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
/**日期div的样式-公历*/
.el-calendar-table .el-calendar-day > div .solar {
  width: 50%;
  height: 22px;
}
/**日期div的样式-农历*/
.el-calendar-table .el-calendar-day > div .lunar {
  width: 50%;
  height: 22px;
  text-align: right;
}
/**日期div的样式-选中*/
.el-calendar-table .el-calendar-day > div.selected {
  background-color: #fef2f2;
  border: 3px solid #fb0;
  border-radius: 20px;
}

/**本月周末设置为红色*/
.el-calendar-table .current:nth-last-child(-n + 2) .solar {
  color: #606266;
}
/**本月农历设置为灰色*/
.el-calendar-table .current .lunar {
  color: #606266;
}
/**本月农历节日设置为红色*/
.el-calendar-table .current .lunar.festival {
  color: #52c5cb;
}
.addbox {
  margin: 10% 0 0 0;
}
.addbox >>> .el-dialog__body {
  padding: 10px 20px;
}
.addboxadd {
  margin: 10% 0 0 0;
}
.addboxadd >>> .el-dialog__header {
  text-align: left;
}
.addboxadd >>> .el-dialog__title {
  font-size: 16px;
  color: #606266;
}
.addboxadd >>> .el-dialog__body {
  padding: 10px 20px 20px 20px;
}
.itemcont {
  font-size: 12px;
  color: rgb(147, 158, 168);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.backhover {
  background: #f5fcfc;
}
.detailsbut {
  color: #fff;
  border: none;
  outline: none;
  background: #0c43c8;
  cursor: pointer;
  padding: 5px 10px 5px 10px;
  border-radius: 3px;
}
.detailsbuts {
  color: #fff;
  border: none;
  outline: none;
  background: #ff0101;
  cursor: pointer;
  padding: 5px 10px 5px 10px;
  border-radius: 3px;
  margin-left: 5px;
}

.incomplete {
  width: 98%;
  margin: auto;
  color: #7b83ea !important;
  background: #e8effa;
  color: #242527;
  line-height: 20px;
  margin-top: 5px;
  border-radius: 5px;
  padding-left: 5px;
}
.complete {
  font-size: 12px;
  width: 56px;
  height: 22px;
  color: #f96d68;
  background: #f5edec;
  border-radius: 11px;
  text-align: center;
  line-height: 22px;
}
.nocomplete {
  font-size: 12px;
  width: 56px;
  height: 22px;
  color: #969eac;
  background: #f4f5f6;
  border-radius: 11px;
  text-align: center;
  line-height: 22px;
}
.pickermonth {
  z-index: -1;
  position: absolute;
  top: 4%;
  left: 10%;
}
.pickermonths {
  position: absolute;
  top: 3%;
  left: 12%;
}
.datepicker >>> .el-date-editor.el-input {
  width: 100%;
}
.pickermonth >>> .el-input__inner {
  height: 38px;
  line-height: 38px;
  border: none;
}

.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>
 